/*
 * View for the status pills used by the topic tasks list
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicTasks/topicTasksListToggle/template/topicTasksListToggleTemplate.html",
], function (Marionette, TopicTasksListToggleTemplate) {
  var TopicTasksListToggleView = {};

  TopicTasksListToggleView.topicTasksListToggleView = Marionette.ItemView.extend({
    template: TopicTasksListToggleTemplate,
    events: {
      //these are events and not triggers so that the event will propagate to Bootstrap
      "click #notStartedTasks": function () {
        this.trigger("show:not:started");
      },
      "click #inProgressTasks": function () {
        this.trigger("show:in:progress");
      },
      "click #rejectedTasks": function () {
        this.trigger("show:rejected");
      },
      "click #allTasks": function () {
        this.trigger("show:all");
      },
    },
    selectNotStarted: function () {
      //Use the bootstrap-y way of selecting the tab
      this.$el.find("a[id=notStartedTasks]").tab("show");
    },
  });

  return TopicTasksListToggleView;
});
